// import { timesheetsRef, quotesRef, restoresRef } from "../firebase";
import { v4 as uuidv4 } from "uuid";
import {
  eicr_remedials_materials,
  eicr_setprices,
  fa_materials,
  fuseboard_materials,
} from "../popData";
import { dateTimeFormatter } from "./dateFormatters";
// import { eicr_setprices, fa_materials } from "../popData";
// import { v4 as uuidv4 } from "uuid";

export const VISIT_CONFIRMATION = "VISIT_CONFIRMATION";
export const ALL_PAID_FA = "ALL_PAID_FA";
export const ALL_PAID_EICR = "ALL_PAID_EICR";
export const ALL_PAID_GENERAL = "ALL_PAID_GENERAL";
export const INVOICE_GENERAL = "INVOICE_GENERAL";
export const INVOICE_FA = "INVOICE_FA";
export const INVOICE_EICR = "INVOICE_EICR";
export const CUSTOMER_ADDRESS = "CUSTOMER_ADDRESS";
export const OVERDUE = "OVERDUE";
export const EICR_QUOTE = "EICR_QUOTE";

// Templates for adding jobDescription and materials to a Primary >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

export function initJobDescription(
  templateType = "BLANK",
  jobDescId,
  userUid,
  operatives,
  rates
) {
  /* 
        Determine which template information should be
        filled into a new job description.
    */

  //   // checks to see if can be filled out properly

  // setup depending on type >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let materials = [];
  let hours = 0;
  let jobDetails = "";
  let setPriceList = [];
  let rateAccessId = "";
  let ratePerHour = "";
  let rateUid = "";

  // set up operatives
  let allOperatives = {};
  operatives.forEach((o) => {
    allOperatives[o.uid] = o.rate;
  });

  if (templateType === "BLANK") {
    // materials = [];
  } else if (templateType === "FA") {
    let t_materials = fa_materials;

    materials = t_materials.map((m) => {
      m.materialCode = uuidv4();
      return m;
    });

    jobDetails =
      "Fire alarm install\n2x smoke detectors (wireless/10)\n1x heat detector (wireless/10)\n1x control panel";
  } else if (templateType === "EICR") {
    setPriceList = [...eicr_setprices];
    jobDetails = "Carry out EICR to property for 6x circuits (£135).";
  } else if (templateType === "FUSE") {
    materials = fuseboard_materials.map((m) => {
      m.materialCode = uuidv4();
      return m;
    });

    jobDetails =
      "Replace old fuse board with new compliant twin RCD consumer unit. Provide appropriate electrical certification.";
    rateAccessId = rates[0]?.accessId || "";
    ratePerHour = rates[0]?.ratePerHour || "";
    rateUid = rates[0]?.uid || "";
    hours = 6;
  } else if (templateType === "EICR_REMEDIALS") {
    materials = eicr_remedials_materials.map((m) => {
      m.materialCode = uuidv4();
      return m;
    });
    jobDetails =
      "Rectify EICR remedial items: 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 1 & 20.";
    rateAccessId = rates[0]?.accessId || "";
    ratePerHour = rates[0]?.ratePerHour || "";
    rateUid = rates[0]?.uid || "";
    hours = 7.5;
  }

  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

  //   // initialise dates
  let timestamped = Date.now();
  let currentDate = dateTimeFormatter(new Date(), "d_full_variant");

  let jd = {
    uid: jobDescId,
    jobDate: currentDate,
    created: timestamped,
    createdBy: userUid,
    details: jobDetails,
    hours: hours,
    materials: materials,
    operatives: allOperatives,
    setPriceList: setPriceList,
    customMaterials: [],
    rateAccessId: rateAccessId,
    rateUid: rateUid,
    ratePerHour: ratePerHour,
  };

  return jd;
}

export function initPrimaryDetails(templateType = "BLANK") {
  /* 
        Determine which template information should be
        filled into a new primary sheet (timesheet, quote etc).
    */

  let jobDetails = "";

  if (templateType === "BLANK") {
    jobDetails = "";
  } else if (templateType === "FA") {
    jobDetails = "Basic fire install";
  } else if (templateType === "EICR") {
    jobDetails = "EICR to property";
  } else if (templateType === "FUSE") {
    jobDetails =
      "Upgrade old fuse board with new BS7671 compliant consumer unit.";
  } else if (templateType === "EICR_REMEDIALS") {
    jobDetails = "EICR Remedials Quote.";
  }

  return {
    jobDetails,
  };
}

// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

export function setupTemplateVariables(formData) {
  let splitName = formData?.authorisedBy?.split(" ");
  // console.log("split", splitName);
  let name = formData?.authorisedBy || "";
  let initials = "--";

  if (splitName?.length > 1) {
    name = splitName[0];

    let firstInitial = String(splitName[0][0]).toUpperCase() ?? "?";
    let secondInitial = String(splitName[1][0]).toUpperCase() ?? "?";

    initials = `${firstInitial}${secondInitial}`;
  }

  let flat = formData?.flat ? `(${formData.flat}) ` : "";
  let address = formData?.address ? formData.address : "ADDRESS";
  let postcode = formData?.postcode ? formData.postcode : "POSTCODE";
  let city = formData?.city || "Glasgow";

  let addressLine = `${flat}${address}, ${postcode}`;

  // Fuller version for email bodies ({{addressLine}} in Create Draft templates) - includes
  // line 2 and the town/city, which the Gmail Add-on in particular relies on (it puts a
  // non-Glasgow town into address2). addressLine above stays short since the PDF's client
  // box already prints address2/city on their own lines underneath it.
  let emailAddressLine = `${flat}${[address, formData?.address2, city, postcode]
    .map((part) => (part || "").trim())
    .filter(Boolean)
    .join(", ")}`;

  let bookedInFullDateTime = dateTimeFormatter(
    formData?.bookedInDateTime,
    "dt_full",
    "BOOKED IN TIME"
  );
  let bookedInDate = dateTimeFormatter(
    formData?.bookedInDateTime,
    "d_full",
    "BOOKED IN TIME"
  );

  let hesNumber = formData?.refNumber || formData?.worksOrderNumber || "[XXXX]";

  let jobDetails = formData?.jobDetails || "[JOB DETAILS]";

  return {
    name,
    initials,
    flat,
    city,
    address,
    postcode,
    addressLine,
    emailAddressLine,
    bookedInFullDateTime,
    bookedInDate,
    hesNumber,
    jobDetails,
  };
}

// Templates for email, copied to clipboard >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
export async function setEmailTemplate(copyType, formData, amount = "XXXX") {
  let textToCopy = "";

  let {
    name,
    initials,
    flat,
    city,
    address,
    postcode,
    addressLine,
    bookedInFullDateTime,
    bookedInDate,
    hesNumber,
    jobDetails,
  } = setupTemplateVariables(formData);
  /*
  &#8195 : tab
  <b> bold </b>
  <em> italic </em>
  */
  // deploy

  let customerAddress = `
  <span><b>${flat}${address}, ${postcode}</b></span>
  `;

  let nameAndWiringRegs = `
  <span><b>Peter</b></span><br>
  <span style="font-size: 8pt"><em>All HES electrical work is carried out to current IET wiring regulations: BS7671:2018/A3:2024.</em></span>
  `;

  let invoiceGeneral = `
  <span>Hi ${name},</span>
  <br><br>
  <span>Re: HES Invoice: <b>${hesNumber}</b> &#8195 <b>Electrical Work</b></span>
  <br><br>
  <span>Please find attached your invoice for the work carried out to your property at:  <em>${flat}</em><b>${address}, ${city}, ${postcode}</b></span>
  <br><br>    
  <span>Banking details for payment are at the bottom of the invoice.</span><br>
  <span>Please simply respond to this email with the word <b>'PAID'</b> with the invoice number ( <b>${hesNumber}</b> ) for our reference.</span>
  <br><br>    
  <span>Many thanks for your appreciated business. We trust that we may be of service to you again in the future.</span>
  <br><br>
  <span>Very Best Regards</span>
  <br><br>
  ${nameAndWiringRegs}
  `;

  let allPaidGeneral = `
  <span>Hi ${name},</span>
  <br><br>
  <span><b>THAT'S IT ALL DONE</b>... Your invoice has now been paid! &#x1F44D;</span>
  <br><br>
  <span>Re: HES Invoice: <b>${hesNumber}</b>  -  Payment Received in full: <b>£${amount}</b> (Many Thanks!)</span>
  <br><br>
  <span>Many thanks for your much appreciated business. We trust that we can be of service to you again in the future.</span>
  <br><br>
  <span>Very Best Regards</span>
  <br><br>
  ${nameAndWiringRegs}
  `;

  let invoiceEICR = `
  <span>Hi ${name},</span>
  <br><br>
  <span>Re: HES Invoice: <b>${hesNumber}</b> &#8195 <b>EICR</b> & <b>PAT</b> Certification</span>
  <br><br>
  <span>Please find attached your invoice for the work carried out to your property at:  <em>${flat}</em><b>${address}, ${city}, ${postcode}</b></span>
  <br><br>    
  <span>Banking details for payment are at the bottom of the invoice.</span><br>
  <span>Please simply respond to this email with the word <b>'PAID'</b> with the invoice number ( <b>${hesNumber}</b> ) for our reference.</span>
  <br><br>    
  <span>Following receipt of payment, your certificates will be directly forwarded asap in <b>PDF</b> format and can be easily forwarded onto your chosen insurance, building control, legal/estate/letting agents etc. if so required.</span>
  <br><br>
  <span>Many thanks for your appreciated business. We trust that we may be of service to you again in the future.</span>
  <br><br>
  <span>Very Best Regards</span>
  <br><br>
  ${nameAndWiringRegs}
  `;

  let invoiceFA = `
  <span>Hi ${name},</span>
  <br><br>
  <span>Re: HES Invoice: <b>${hesNumber}</b> &#8195 Fire Alarm Installation.</span>
  <br><br>
  <span>Please find attached your invoice for the work carried out to your property recently at:  <em>${flat}</em><b>${address}, ${city}, ${postcode}</b>.</span>
  <br><br>    
  <span>Banking details for payment are at the bottom of the invoice.</span><br>
  <span>Please simply respond to this email with the word <b>'PAID'</b> with the invoice number <b>( ${hesNumber} )</b> for our reference.</span>
  <br><br>    
  <span>Following receipt of payment, your <b>BS5839 Fire Alarm & Electrical</b> certificates will be directly forwarded asap in PDF format and can be easily forwarded onto your chosen building control, legal/estate/letting agents etc. if so required.</span>
  <br><br>
  <span>Many thanks for your appreciated business. We trust that we may be of service to you again in the future.</span>
  <br><br>
  <span>Very Best Regards</span><br><br>
  ${nameAndWiringRegs}
  `;

  // All electrical work is carried out to current IET wiring regulations: BS7671:2018.
  let allPaidFA = `
  <span>Hi ${name},</span>
  <br><br>
  <span><b>THAT'S IT ALL DONE</b>... Your Fire Alarm installation has now been completed successfully! &#x1F44D;</span>
  <br><br>
  <span>Re: HES Invoice: <b>${hesNumber}</b>  -  Payment Received in full: <b>£${amount}</b> (Many Thanks!)  -  FA Certification Attached.</span>
  <br><br>
  <span>Please find attached your completed <b>Fire Alarm</b> & <b>Minor Works</b> certification following the installation work carried out to your property at:</span>
  <br>
  <span><em>${flat}</em><b>${address}, ${city}, ${postcode}</b></span>
  <br><br>
  <span>Your certificates are in <b>PDF</b> format and can be easily forwarded onto your chosen insurance, building control, legal/estate/letting agents etc. if so required.</span>
  <br>
  <span>Many thanks for your much appreciated business. We trust that we can be of service to you again in the future.</span>
  <br><br><br>
  <span>Very Best Regards</span>
  <br><br>
  ${nameAndWiringRegs}
  `;

  let allPaidEICR = `
  <span>Hi ${name},</span>
  <br><br>
  <span><b>THAT'S IT ALL DONE</b>... Your <b>EICR</b> & <b>PAT</b> certification has now been completed!</span>
  <br>
  <span>Re: HES Invoice: <b>${hesNumber}</b>  -  Payment Received in full <b>(£${amount})</b>... Many Thanks!</span>
  <br><br>
  <span>Re:  <b>EICR</b> & <b>PAT</b> Certification</span>
  <br><br>
  <span>Please find attached your certification for the EICR and PAT testing carried out to your property at:</span>
  <br>
  <span><em>${flat}</em><b>${address}, ${city}, ${postcode}</b></span>
  <br><br>
  <span>Your certification is in <b>PDF</b> format which can be easily forwarded onto your chosen building dept./legal/estate/letting/insurance agents etc. if so required.</span>
  <br><br>
  <span>Following an <b>'Unsatisfactory'</b> outcome to your <b>EICR</b>, the reasons causing this are mentioned in the <b>'Observations'</b> section of your EICR on <b>page 3</b>. Should you wish for a remedial estimate to rectify the problems identified, please simply reply to this email with (  <b>${hesNumber} - Remedial Estimate</b> ) and I will have one made up for you. This estimate includes an EICR updated retest certificate to a <b>'Satisfactory'</b> standard.</span> 
  <br><br>
  <span>If you require any additional information regarding the above, please do not hesitate to contact me and I will be happy to advise accordingly.</span>
  <br><br>
  <span>Many thanks for your much appreciated business. We trust that we can be of service to you again in the future.</span>
  <br><br><br>
  <span>Very Best Regards</span>
  <br><br>
  ${nameAndWiringRegs}
  `;

  // let visitConfirmationEmail = `
  //     <span>Hi ${name},</span><br><br><span>Re: Visit Confirmation - Smoke Alarm Install- (${initials}.INIT.001):</span><br><span><b>${flat}${address}, ${postcode}</b></span><br><br><span>Just a quick email to confirm our agreed visit time of</span><br><span><b>${bookedInTime}</b></span><br><br><span>To carry out the smoke detector installation as previously quoted/discussed.</span><br><span>Many thanks for your appreciated business!</span><br><br><span>Best Regards</span><br><span><b>Peter</b></span>`;

  let visitConfirmationEmail = `
  <span>Hi ${name},</span>
  <br><br>
  <span>Re: Visit Confirmation - (${initials}.INIT.001):</span>
  <br>
  <span><em>${flat}</em><b>${address}, ${city}, ${postcode}</b></span>
  <br><br>
  <span>Just a quick email to confirm our agreed visit time of</span>
  <br>
  <span><b>${bookedInFullDateTime}</b></span>
  <br><br>
  <span>To carry out the work as previously quoted/discussed.</span>
  <br>
  <span>Many thanks for your appreciated business!</span>
  <br><br>
  <span>Very Best Regards</span>
  <br>
  <span><b>Angela</b></span>`;

  let overdue = `<span>Hi ${name},</span> 
  <br><br>  
  <span>This invoice has been flagged up as yet to be paid. Can you look into this and advise accordingly?</span>
  <br><br>
  <span><b>Invoice Payment Reminder</b></span>
  <br><br>  
  <span>Re: HES Invoice: <b>${hesNumber}</b> &emsp;  <em>${flat}</em><b>${address}, ${city}, ${postcode}</b> &nbsp;&nbsp;(<em>${jobDetails}</em>).</span>
  <br><br> 
  <span>Please find attached, a copy of the above invoice for the electrical work carried out on <b>${bookedInDate}</b>.</span>
  <br>
  <span>Banking details for payment are at the bottom of the invoice. Please simply respond to this email with the word 'PAID' with the invoice number ( <b>${hesNumber}</b> ) for our reference.</span>
  <br><br>
  <span>Very Best Regards</span>
  <br><br>
  <span><b>Angela</b></span>`;

  /*
<span>Hi ${name},

Re: EICR Remedials Quotation  -  HES 588         Address:  (Flat 2/2) 48 Edgehill Road, Glasgow, G11 7JD

Please find below your remedial quotation as requested, following our visit to your premises recently to carry out an electrical EICR test. 

On page 3 (Observations) of your report, items  1, 2, 3, 4, 5, 6, 7, 8, 11 & 13  have been identified in your report that require remedial action. 
Rectification of the above remedial items will allow us to update your EICR accordingly and conclude onto a 'Satisfactory' outcome for your EICR report.
                                                                                                                                                 
All materials have been sourced for best pricing and quality and I trust that my quote proves to be competitive for you. This quotation includes materials, labour & certification with no VAT to be added later!  Should you wish to proceed with it.... just confirm via responding with the words   'PROCEED - REMEDIALS'   to this email and I will order your materials and contact you to arrange an access date that best suits.

Very Best Regards

Peter
  */

  let eicrQuote = `
  <span>Hi ${name},</span>
  <br><br>
  <span>Re: <b>EICR</b> Remedials Quotation - HES <b>${hesNumber}</b> &#8195 <b>Address</b>: <em>${flat}</em><b>${address}, ${city}, ${postcode}</b></span>
  <br><br>
  <span>Please find below your remedial quotation as requested, following our visit to your premises recently to carry out an electrical EICR test.</span>
  <br><br>    
  <span>On page <b>3</b> (Observations) of your report, items  <b>1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12</b> & <b>13</b>  have been identified in your report that require remedial action. 
  Rectification of the above remedial items will allow us to update your EICR accordingly and conclude onto a <b>'Satisfactory'</b> outcome for your EICR report.</span>
  <br><br>    
  <span>All materials have been sourced for best pricing and quality and I trust that my quote proves to be competitive for you. This quotation includes <b>materials, labour & certification</b> with <b>no</b> VAT to be added later!  Should you wish to proceed with it.... just confirm via responding with the words   <b>'PROCEED - REMEDIALS'</b>   to this email and I will order your materials and contact you to arrange an access date that best suits.</span>
  <br><br>
  <span>Many thanks for your appreciated business. We trust that we may be of service to you again in the future.</span>
  <br><br>
  <span>Very Best Regards</span>
  <br><br>
  ${nameAndWiringRegs}
  
  
  
  `;

  const templates = {
    [VISIT_CONFIRMATION]: visitConfirmationEmail,
    [ALL_PAID_FA]: allPaidFA,
    [ALL_PAID_EICR]: allPaidEICR,
    [ALL_PAID_GENERAL]: allPaidGeneral,
    [INVOICE_GENERAL]: invoiceGeneral,
    [INVOICE_FA]: invoiceFA,
    [INVOICE_EICR]: invoiceEICR,
    [CUSTOMER_ADDRESS]: customerAddress,
    [OVERDUE]: overdue,
    [EICR_QUOTE]: eicrQuote,
  };

  textToCopy = templates[copyType];

  // switch (copyType) {
  //   case "VISIT_CONFIRMATION": {
  //     textToCopy = visitConfirmationEmail;
  //     break;
  //   }
  //   case "ALL_PAID_FA": {
  //     textToCopy = allPaidFA;
  //     break;
  //   }
  //   case "ALL_PAID_EICR": {
  //     textToCopy = allPaidEICR;
  //     break;
  //   }
  //   case "ALL_PAID_GENERAL": {
  //     textToCopy = allPaidGeneral;
  //     break;
  //   }
  //   case "INVOICE_GENERAL": {
  //     textToCopy = invoiceGeneral;
  //     break;
  //   }
  //   case "INVOICE_FA": {
  //     textToCopy = invoiceFA;
  //     break;
  //   }
  //   case "INVOICE_EICR": {
  //     textToCopy = invoiceEICR;
  //     break;
  //   }
  //   case "CUSTOMER_ADDRESS": {
  //     textToCopy = customerAddress;
  //     break;
  //   }
  //   case "OVERDUE": {
  //     textToCopy = overdue;
  //     break;
  //   }
  //   default: {
  //     textToCopy = "";
  //   }
  //}

  // await navigator.clipboard.writeText(textToCopy);

  var type = "text/html";
  let ClipboardItem = window.ClipboardItem;
  var blob = new Blob([textToCopy], { type });
  var data = [new ClipboardItem({ [type]: blob })];

  return data;
}

// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
